import CheckoutPanel from 'checkout/components/CheckoutPanel'
import { CheckoutQA } from 'shared/dataAttributes'
import { ShippingMethodForm } from 'checkout/panels/ShippingMethod/ShippingMethodForm'
import { ShippingMethodSummary } from 'checkout/panels/ShippingMethod/ShippingMethodSummary'
import { t } from 'localization'

const TP = 'checkout.panels.ShippingMethod.ShippingMethodPanel'

export const ShippingMethodPanel = () => {
  return (
    <CheckoutPanel
      expandedContent={<ShippingMethodForm />}
      name="shippingMethod"
      qaAttr={CheckoutQA.ShippingMethod}
      summarizedContent={<ShippingMethodSummary />}
      title={t(`${TP}.shippingMethod`, 'Shipping Method')}
    />
  )
}
